import { useState } from 'react';
import { useProviderListQuery } from '@common/cache';
import { useDrawerStore } from 'store/drawer.store.ts';
import { IProviderTableEntry } from '../hooks/useProviderTable';
import { useProviderTableStore } from '../Filters/filters.store';

export const useProvider = () => {
  const { filters, appliedFiltersCount } = useProviderTableStore();
  const [isCreateProviderModalOpen, setIsCreateProviderModalOpen] =
    useState(false);
  const [isImportProviderModalOpen, setIsImportProviderModalOpen] =
    useState(false);
  const [selectedProviderId, setSelectedProviderId] = useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = {
      count: 0,
      records: [],
    },
    isRefetching,
    isFetching,
  } = useProviderListQuery(filters);

  const entries: IProviderTableEntry[] = data.records;

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedProviderId('');
  };

  const handleOpenProviderDetails = (id: string) => {
    setSelectedProviderId(id);
    setDrawerOpen(true);
  };

  const handleOpenCreateProviderModal = () => {
    setIsCreateProviderModalOpen(true);
  };

  const handleCloseCreateProviderModal = () => {
    setIsCreateProviderModalOpen(false);
  };

  const handleOpenImportProviderModal = () => {
    setIsImportProviderModalOpen(true);
  };

  const handleCloseImportProviderModal = () => {
    setIsImportProviderModalOpen(false);
  };

  return {
    entries,
    totalCount: data.count,
    filters,
    isInitialFilters: appliedFiltersCount === 0 && !filters.search,
    selectedProviderId,
    handleCloseDrawer,
    handleOpenProviderDetails,
    handleOpenCreateProviderModal,
    handleCloseCreateProviderModal,
    handleOpenImportProviderModal,
    handleCloseImportProviderModal,
    isCreateProviderModalOpen,
    isImportProviderModalOpen,
    isDrawerOpen,
    isLoading: isFetching || isRefetching,
  };
};
